import { type UseMutationOptions, useMutation } from '@tanstack/react-query';
import type {
  BulkImportCsvV1WorkspacesWorkspaceIdBulkImportCsvPostData,
  BulkImportCsvV1WorkspacesWorkspaceIdBulkImportCsvPostError,
  BulkImportCsvV1WorkspacesWorkspaceIdBulkImportCsvPostResponse,
} from '../../generated';
import { multipartPost } from '../../utils';

export type BulkImportCsvMutationVariables = BulkImportCsvV1WorkspacesWorkspaceIdBulkImportCsvPostData['path'] &
  BulkImportCsvV1WorkspacesWorkspaceIdBulkImportCsvPostData['body'];

export type BulkImportCsvMutation = BulkImportCsvV1WorkspacesWorkspaceIdBulkImportCsvPostResponse;

export const useBulkImportCsvMutation = <
  TError = BulkImportCsvV1WorkspacesWorkspaceIdBulkImportCsvPostError,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<BulkImportCsvMutation, TError, BulkImportCsvMutationVariables, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) => {
  return useMutation<BulkImportCsvMutation, TError, BulkImportCsvMutationVariables, TContext>({
    mutationKey: ['BulkImportCsv'],
    mutationFn: ({ workspace_id, file }: BulkImportCsvMutationVariables) =>
      multipartPost<BulkImportCsvMutation>('/v1/workspaces/{workspace_id}/bulk-import/csv', file, {
        workspace_id,
      }),
    ...options,
  });
};
